import React, { useContext, useMemo } from "react";
import ElemSlide from "./ElemSlide";
import Logo from "./Logo";
import Button_icon from "./Button_icon";
import off_svg from "../img/Off_On.svg";
import { useAuth } from "react-oidc-context";
import { Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { HotelContext } from "../context/HotelContext";
import { useAccessiblePages } from "../hooks/usePageAccess";

function Slidebar(props) {
  const { hId, lang, setLang, accessRights } = useContext(HotelContext);
  const location = useLocation();
  const path = location.pathname;
  const hotelIsSelected = hId ? true : false;
  const keycloak = useAuth();

  // Récupérer les pages accessibles pour filtrer la sidebar
  const { pages: accessiblePages, loading: accessiblePagesLoading } = useAccessiblePages(hId);

  // Créer un Set des noms de pages accessibles pour un accès rapide
  const accessiblePageNames = useMemo(() => {
    const pageNames = new Set(accessiblePages.map((page) => page.pName));
    return pageNames;
  }, [accessiblePages]);

  // Mapping des URLs/viewID vers les noms de pages dans la DB
  const pageNameMap = {
    "/hotel/lunishower/dashboard": "dashboard",
    "/hotel/lunishower/consommation": "consommation",
    "/hotel/lunishower/economies": "economies",
    "/hotel/lunishower/badges": "badges",
    "/hotel/lunishower/stats": "stats",
    "/hotel/lunishower/donation": "donation",
    "/hotel/lunishower/customer_xp": "customer_xp",
    "/hotel/lunishower/abonnement": "abonnement",
    "/settings/hotel/informations": "hotelInformations",
    "/settings/hotel/rooms": "rooms_settings",
    "/hotel/greenmiles/dashboard": "dashboard-gm",
    "/hotel/greenmiles/rewards": "rewards",
    "/hotel/greenmiles/actionsrse": "actions-rse",
    "/hotel/greenmiles/declined-services": "declined-services",
  };

  // Helper pour vérifier si une page est accessible
  const isPageAccessible = (url) => {
    const pageName = pageNameMap[url];
    if (!pageName) {
      // Si la page n'est pas dans le mapping, on l'affiche (pour les pages user, etc.)
      return true;
    }
    // Pages de réglages : toujours accessibles si l'utilisateur a un hôtel sélectionné
    const settingsPages = ["hotelInformations", "rooms_settings"];
    if (settingsPages.includes(pageName) && hId) {
      return true;
    }
    // Si pas d'hôtel sélectionné ou pas encore chargé, on affiche tout (pour éviter le flash)
    if (!hId || accessiblePagesLoading) {
      return true;
    }
    return accessiblePageNames.has(pageName);
  };

  const handleLogout = () => {
    keycloak.signoutRedirect();
  };

  return (
    <div className="panel-left">
      {path.includes("settings") ? (
        <Logo name="Reglages"/>
      ) : path.includes("greenmiles") ? (
        <Logo name="Greenmiles" />
      ) : (
        <Logo name="Lunishower" />
      )}


      <div className="grpElemSlide">
        {hotelIsSelected ? (
          path.includes("/settings") ? (
            <>
              {isPageAccessible("/settings/hotel/informations") && (
                <ElemSlide select={props.viewID == "hotelInformations" ? "select" : ""} name="Informations générales" url={"/settings/hotel/informations"} />
              )}
              {isPageAccessible("/settings/hotel/rooms") && (
                <ElemSlide select={props.viewID == "Rooms" ? "select" : ""} name="Gestion des chambres" url={"/settings/hotel/rooms"} />
              )}
              {/* <ElemSlide select={props.viewID == "myAccess" ? "select" : ""} name="Gestion des accès" url={"/settings/hotel/access"} /> */}
              {/* <ElemSlide select={props.viewID == "devices" ? "select" : ""} name="Gestion des appareils" url={"/settings/hotel/devices"} /> */}
            </>
          ) : path.includes("/greenmiles") ? (
            <>
              {isPageAccessible("/hotel/greenmiles/declined-services") && (
                <ElemSlide
                  select={props.viewID === "declinedServices" ? "select" : ""}
                  name="Declined_services_title"
                  url={"/hotel/greenmiles/declined-services"}
                />
              )}
            </>
          ) : (
            <>
              {isPageAccessible("/hotel/lunishower/dashboard") && (
                <ElemSlide select={props.viewID == "Dashboard" ? "select" : ""} name="Dashboard_title" url={"/hotel/lunishower/dashboard"} />
              )}
              {isPageAccessible("/hotel/lunishower/consommation") && (
                <ElemSlide select={props.viewID == "Consommation" ? "select" : ""} name="Conso_title" url={"/hotel/lunishower/consommation"} />
              )}
              {isPageAccessible("/hotel/lunishower/economies") && (
                <ElemSlide select={props.viewID == "Economies" ? "select" : ""} name="Eco_title" url={"/hotel/lunishower/economies"} />
              )}
              {isPageAccessible("/hotel/lunishower/badges") && (
                <ElemSlide select={props.viewID == "badges" ? "select" : ""} name="Badges" url={"/hotel/lunishower/badges"} />
              )}
              {isPageAccessible("/hotel/lunishower/stats") && (
                <ElemSlide select={props.viewID == "stats" ? "select" : ""} name="Room_stat" url={"/hotel/lunishower/stats"} />
              )}
              {isPageAccessible("/hotel/lunishower/donation") && (
                <ElemSlide select={props.viewID == "donation" ? "select" : ""} name="donation_title" url={"/hotel/lunishower/donation"} />
              )}
            </>
          )
        ) : (
          <>
            <ElemSlide select={props.viewID == "myHotels" ? "select" : ""} name="mes_hotels" url={"/user/hotels"} />
            <ElemSlide select={props.viewID == "personalInformations" ? "select" : ""} name="mes_infos" url={"/user/informations"} />
            <ElemSlide select={props.viewID == "statistics" ? "select" : ""} name="Mes statistiques" url={"/user/statistics"} />
            <ElemSlide select={props.viewID == "preferences" ? "select" : ""} name="Mes préférences" url={"/user/preferences"} />
            <ElemSlide select={props.viewID == "accessAPI" ? "select" : ""} name="Accès API" url={"/user/accessAPI"} />
          </>
        )}
      </div>

      <div className="deco_button">
        <Button type="button" className="icon-button-3 langBtn" onClick={() => setLang((lang) => (lang === "fr" ? "en" : "fr"))}>
          {lang.toUpperCase()}
        </Button>
        {/* Bouton d'information */}
        {/* <Button_icon imageSrc={info_svg} onButtonClick={() => {}} /> */}
        {/* Bouton de déconnexion */}
        <Button_icon imageSrc={off_svg} onButtonClick={handleLogout} />
      </div>
    </div>
  );
}

export default Slidebar;
